const funcion9 = {
  titulo: `Función: callback y funciones anónimas`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Una función callback es aquella que es pasada como argumento y recibida como parámetro por otra función, dentro del algoritmo de esa función procederá a llamar a la función cuando se necesite.`,
      programa: `function sumar(v1, v2) {
  return v1 + v2
}

function multiplicar(v1, v2) {
  return v1 * v2
}

function operar(v1, v2, cb) {
  const resultado = cb(v1, v2)
  return resultado
}

const resultado = operar(5, 10, sumar)
console.log(resultado)`,
      solucion: "15"
    }, {
      codigo: 2,
      descripcion: `En el problema anterior la función operar recibe como parámetro una función, que es la función que se ejecuta cuando se necesita realizar una operación. El parámetro cb puede recibir la referencia de alguna de las dos funciones: sumar o multiplicar.
Veamos otro ejemplo con la función mayorEdad que recibe como parámetro una función.`,
      programa: `function mayorEdad(edad, cb) {
  if (cb(edad)) {
    return true
  } else {
    return false
  }
}

function mayorEdadArgentina(edad) {
  if (edad >= 18) {
    return true
  } else {
    return false
  }
}

function mayorEdadEEUU(edad) {
  if (edad >= 21) {
    return true
  } else {
    return false
  }
}

const edadPersona = 20
if (mayorEdad(edadPersona, mayorEdadEEUU)) {
  console.log("Es mayor de edad")
} else {
  console.log("Es menor de edad")
}`,
      solucion: "'Es menor de edad'"
    }, {
      codigo: 3,
      descripcion: `Una función anónima no tiene nombre y normalmente se pasa como argumento a otra función que la recibe como parámetro. Como vemos el tema está íntimamente relacionado con las funciones callback.
Los problemas anteriores son más común resolverlos con funciones anónimas.`,
      programa: `function operar(v1, v2, cb) {
  let resultado = cb(v1, v2)
  return resultado
}

const resultado = operar(5, 10, function (v1, v2) { return v1 + v2 })
console.log(resultado)`,
      solucion: "15"
    }, {
      codigo: 4,
      descripcion: ``,
      programa: `function mayorEdad(edad, cb) {
  if (cb(edad)) {
    return true
  } else {
    return false
  }
}

const edadPersona = 20
if (mayorEdad(edadPersona, function (edad) {
  if (edad >= 21)
    return true
  else
    return false
})) {
  console.log("Es mayor de edad")
} else {
  console.log("Es menor de edad")
}`,
      solucion: "'Es menor de edad'"
    }
  ]
}

export default funcion9;